import defaultsDeep from 'lodash/defaultsDeep';

import defaultBg from './assets/backgrounds/HeroBackground-Option1-01.png';
import defaultBg2 from './assets/backgrounds/HeroBackground-Option2-01.png';
import defaultBg3 from './assets/backgrounds/HeroBackground-Option3-01.png';

import apTrustedSourcesBg from './assets/backgrounds/app-platform-login-promo-bg-v2.jpg';
import refBadgeBg from './assets/backgrounds/referral-badge-bg-1680x1050px.jpg';
import refBadgeLogo from './assets/referral_badge_icon_400x200px.png';

import { LoginVariant } from './interfaces/login';

interface VariantMap {
  [id: string]: LoginVariant;
}

const defaults = {
  type: 'default',
  textColor: 'white',
  background: {
    image: defaultBg,
    horizontalPosition: 'center',
    verticalPosition: 'center',
    height: '180px',
    width: '360px'
  }
};

export const newBg2 = defaultsDeep(
  {
    type: 'newBg2',
    background: {
      image: defaultBg2
    }
  },
  defaults
);

export const newBg3 = defaultsDeep(
  {
    type: 'newBg3',
    background: {
      image: defaultBg3
    }
  },
  defaults
);

export const refBadge = defaultsDeep(
  {
    type: 'refBadge',
    background: {
      image: refBadgeBg
    },
    image: refBadgeLogo,
    title: 'Introducing the "Powered by \n DigitalOcean" Referral Badge',
    subtitle:
      'Embed your referral program badge on your site and become eligible to earn free credits when a new user signs up.',
    button: {
      variation: 'success',
      text: 'Learn more',
      url:
        'https://www.digitalocean.com/blog/powered-by-digitalocean-referral-badge/?utm_medium=cloud&utm_source=login&utm_content=content'
    }
  },
  defaults
);

export const apTrustedSources = defaultsDeep(
  {
    type: 'apTrustedSources',
    background: {
      image: apTrustedSourcesBg
    },
    title: 'Introducing Trusted \n Sources in App Platform',
    subtitle:
      'Add your app built on DigitalOcean App Platform as a trusted source for Managed Databases \n for stronger security',
    button: {
      variation: 'banner',
      text: 'Learn more',
      url:
        'https://www.digitalocean.com/blog/new-in-digitalocean-app-platform-enhanced-security-insights-and-dbaas-integration?utm_medium=cloud&utm_source=login&utm_content=content'
    }
  },
  defaults
);

export const teamVariant = defaultsDeep(
  {
    type: 'team',
    title: 'Join your team on DigitalOcean!',
    subtitle:
      '{{name}} has invited you to join them. Sign in and start making waves with your team today!'
  },
  defaults
);

// These are for randomly choosing login variants
const loginVariants: VariantMap = {
  primary: newBg3,
  refBadge,
  apTrustedSources
};

export default loginVariants;
